import React, { useEffect, useId, useState } from 'react';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import styles from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SavedTextareaProps {
  label: string;
  value: string;
  /** Called on blur when the text changed. */
  onSave: (value: string) => void;
  maxLength: number;
  hint?: string;
  rows?: number;
  disabled?: boolean;
  /** One line: an input, not a text area. */
  singleLine?: boolean;
}

/** A field that saves when it loses the focus (design outreach b1: "every edit saves at once"). */
const SavedTextareaComponent: React.FC<SavedTextareaProps> = ({
  label,
  value,
  onSave,
  maxLength,
  hint,
  rows = 3,
  disabled = false,
  singleLine = false,
}) => {
  const id = useId();
  const [draft, setDraft] = useState(value);
  useEffect(() => setDraft(value), [value]);
  const save = () => {
    if (draft !== value) {
      onSave(draft);
    }
  };

  return (
    <div>
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      {singleLine ? (
        <input
          id={id}
          className={styles.input}
          value={draft}
          maxLength={maxLength}
          disabled={disabled}
          onChange={(event) => setDraft(event.target.value)}
          onBlur={save}
        />
      ) : (
        <textarea
          id={id}
          className={styles.textarea}
          value={draft}
          rows={rows}
          maxLength={maxLength}
          disabled={disabled}
          onChange={(event) => setDraft(event.target.value)}
          onBlur={save}
        />
      )}
      {hint !== undefined && <p className={`${styles.small} mt-1`}>{hint}</p>}
    </div>
  );
};

export const SavedTextarea = TypedMemo(SavedTextareaComponent);
